import React from 'react'
import { Link } from 'react-router-dom'

const Maintenance = () => {
    return (
        <div className="flex justify-center">
            <div className="md:w-full p-7 bg-white border rounded auth-body">
                <form>
                    <ul className="grid gap-4 list-none li_animate">
                        <li className="col-span-12">
                            <h3 className="text-xl font-semibold">Under Construction!</h3>
                            <p>Our website / Webapp is under construction, but we are ready to go! Special surprise for subscribers only.</p>
                        </li>
                        <li className="col-span-12">
                            <label htmlFor='emailnotification' className="block text-sm font-medium text-gray-700">Get notified when we are done.</label>
                            <input
                                type="email"
                                id='emailnotification'
                                className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0 mt-2"
                                placeholder="name@gmail.com"
                            />
                        </li>
                        <li className="col-span-12 mt-6 mb-4">
                            <Link
                                className="block w-full py-3 bg-primary-900 text-white text-center rounded-lg uppercase hover:bg-primary-800 transition"
                                to="/two-step"
                                title=""
                            >
                                Notify Me
                            </Link>
                        </li>
                        <li className="col-span-12 text-center">
                            <span className="text-gray-500">
                                <Link className="text-accent" to="/signin">Back to Sign in</Link>
                            </span>
                        </li>
                    </ul>
                </form>
            </div>
        </div>
    )
}

export default Maintenance